import React, { createContext, useContext, useState, useEffect } from 'react';
import { UI_TRANSLATIONS, SUPPORTED_LANGUAGES, detectBrowserLanguage, getTranslation } from '../i18n/translations';
import { safeStorage } from '../lib/safeStorage';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    // Check storage first, then detect from browser
    const saved = safeStorage.getItem('axiom_language');
    return saved || detectBrowserLanguage();
  });

  useEffect(() => {
    safeStorage.setItem('axiom_language', language);
    // Update document lang attribute for accessibility
    document.documentElement.lang = language;
  }, [language]);

  // Translation function - use as t('nav.dashboard')
  const t = (path) => {
    return getTranslation(language, path);
  };

  // Get all translations for current language
  const translations = UI_TRANSLATIONS[language] || UI_TRANSLATIONS['en'];

  const value = {
    language,
    setLanguage,
    t,
    translations,
    supportedLanguages: SUPPORTED_LANGUAGES
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}

export default LanguageContext;
